import {
  FETCH_AI_CONFIG,
  FETCH_AI_CONFIG_SUCCESS,
  FETCH_AI_CONFIG_FAILED,
  EDIT_AI_CONFIG,
} from '../store/types';
import { firebase } from '../config/configureFirebase';
import { onValue, set } from 'firebase/database';

export const fetchAiConfig = () => (dispatch) => {
  const { aiConfigRef } = firebase;
  dispatch({ type: FETCH_AI_CONFIG, payload: null });
  onValue(aiConfigRef, (snapshot) => {
    dispatch({
      type: FETCH_AI_CONFIG_SUCCESS,
      payload: snapshot.val() || {},
    });
  }, (error) => {
    dispatch({ type: FETCH_AI_CONFIG_FAILED, payload: error.message });
  });
};

export const editAiConfig = (config) => (dispatch) => {
  const { aiConfigRef } = firebase;
  dispatch({ type: EDIT_AI_CONFIG, payload: config });
  return set(aiConfigRef, config);
};
